// `key` is the result field name; `sortKey` is the order_by value (omitted when not sortable).
// `width` is in px; values are estimates taken from the design, adjust here if needed.
export const REGISTRATION_DATA_COLUMNS = [
  { key: 'id', label: 'User ID', sortKey: 'id', width: 100 },
  { key: 'username', label: 'Username', sortKey: 'username', width: 100 },
  { key: 'name', label: 'Full Name', sortKey: 'name', width: 140 },
  { key: 'email', label: 'Email Address', sortKey: 'email', width: 220 },
  { key: 'role_label', label: 'User Role', sortKey: 'role', width: 130 },
  { key: 'gender', label: 'Gender', sortKey: 'gender', width: 100 },
  { key: 'trn', label: 'TRN', sortKey: 'trn', width: 100 },
  { key: 'parish', label: 'Parish', sortKey: 'parish', width: 100 },
  { key: 'region', label: 'Region', sortKey: 'region', width: 90 },
  { key: 'physical_address', label: 'Physical Address', width: 220 },
  { key: 'mailing_address', label: 'Mailing Address', width: 200 },
  { key: 'telephone', label: 'Telephone Number', width: 160 },
  { key: 'other_numbers', label: 'Other Number(s)', width: 150 },
  { key: 'job_title', label: 'Job Title', sortKey: 'job_title', width: 110 },
  { key: 'photo_id_type', label: 'Photo ID Type', width: 140 },
  { key: 'photo_id_number', label: 'Photo ID Number', width: 150 },
  { key: 'id_expiration_date', label: 'ID Expiration', sortKey: 'id_expiration_date', width: 130 }
];

// Shown before the last 4 characters of the photo ID number returned by the API.
export const PHOTO_ID_MASK_PREFIX = '••• •• ';

export const REGISTRATION_DATA_PAGE_SIZE = 10;
export const REGISTRATION_DATA_DEFAULT_ORDER = { column: 'name', direction: 'asc' };

// Known role codes get a tinted pill (see the registration-data styles); others fall back to the grey one.
export const REGISTRATION_ROLE_CODES = [
  'administrator',
  'staff',
  'course_author',
  'instructor',
  'support_user',
  'learner'
];
